export default __webpack_public_path__ + "static/media/FillOrder.b5b6c3d6.svg";